module.exports = __webpack_public_path__ + "static/media/Frame 2812.d2894c51.jpg";